import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const ToggleBoxStyled = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
  p: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    width: 100%;
    cursor: pointer;
  `}
`;
